
import { motion } from 'framer-motion';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-inbox-line',
      title: 'Coletas Empresariais',
      description: 'Coleta de assinaturas em cartórios, reconhecimento de firma e documentos corporativos com agilidade e segurança.',
      image: 'https://r.mobirisesite.com/729997/assets/images/caixa-para-entrega-353x235.png',
    },
    {
      icon: 'ri-tools-fill',
      title: 'Transporte de Peças e Manutenção',
      description: 'Entrega rápida de peças automotivas, equipamentos e materiais para manutenção industrial e comercial.',
      image: 'https://public.readdy.ai/ai/img_res/6f01ee3c7b29ecfa92d08850bccfa007.jpg',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Malotes e Documentos Corporativos',
      description: 'Transporte seguro de malotes, contratos, documentos fiscais e correspondências empresariais urgentes.',
      image: 'https://r.mobirisesite.com/729997/assets/images/1428118-mao-segurando-um-documento-foto-561x373.jpg',
    },
    {
      icon: 'ri-car-line',
      title: 'Transporte com Carro e Caminhão',
      description: 'Entregas de médio e grande volume com veículos adequados para cada tipo de carga empresarial.',
      image: 'https://r.mobirisesite.com/729997/assets/images/istockphoto-1446347467-353x199.jpeg',
    },
    {
      icon: 'ri-motorbike-line',
      title: 'Entregas Rápidas com Moto',
      description: 'Serviço expresso para entregas urgentes em áreas urbanas com agilidade e pontualidade garantidas.',
      image: 'https://r.mobirisesite.com/729997/assets/images/istockphoto-1463429744-561x374.jpg',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Serviços Fixos e Esporádicos',
      description: 'Atendimento sob demanda ou contratos mensais fixos adaptados às necessidades da sua empresa.',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20calendar%20and%20scheduling%20concept%20with%20delivery%20vehicles%20representing%20flexible%20corporate%20logistics%20services%20fixed%20and%20on-demand%20transportation%20solutions%20clean%20modern%20background&width=600&height=400&seq=rbf-service-006&orientation=landscape',
    },
  ];

  return (
    <section id="servicos" className="bg-gradient-to-b from-white to-[#f8f9fa] py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1a237e] mb-4">Nossos Serviços</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Soluções completas de transporte empresarial para atender todas as necessidades logísticas da sua empresa
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a237e]/98 via-[#1a237e]/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-11 h-11 flex items-center justify-center bg-white/25 backdrop-blur-md rounded-lg shadow-lg">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl font-bold mb-3 leading-tight">{service.title}</h3>
                <p className="text-white/90 text-sm mb-5 leading-relaxed">{service.description}</p>
                <a
                  href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-white border border-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-white hover:text-[#1a237e] transition-all whitespace-nowrap"
                >
                  Cotar este Serviço
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
